<div class="modal-header">
    <h3 class="modal-title" id="modal-title" translate="DEVICE_LOCK.title"></h3>
    @if (!loading && closable) {
        <span class="close" (click)="modalInstance.hide()">&times;</span>
    }
</div>
<div class="modal-body device-lock-error-modal-body">
    @if (isResetWarningDisplayed()) {
        <div
            class="border border-warning-subtle my-3 mx-auto p-3 warning-max-width d-flex flex-column justify-content-center align-items-center"
        >
            <div class="h3" [translate]="'DEVICE_LOCK.RESET_WARNING.title'"></div>
            <p [translate]="'DEVICE_LOCK.RESET_WARNING.body1'"></p>
            <ul>
                <li [translate]="'DEVICE_LOCK.RESET_WARNING.instruction1'"></li>
                <li [translate]="'DEVICE_LOCK.RESET_WARNING.instruction2'"></li>
            </ul>
            <p [translate]="'DEVICE_LOCK.RESET_WARNING.body2'"></p>
            <div class="w-100 d-flex flex-row justify-content-end gap-2">
                <button
                    type="button"
                    class="btn btn-secondary"
                    (click)="isResetWarningDisplayed.set(false)"
                    [translate]="'DEVICE_LOCK.RESET_WARNING.CANCEL_ACTION'"
                    [disabled]="loading || !isResetWarningDisplayed()"
                ></button>
                <button
                    type="button"
                    class="btn btn-warning"
                    (click)="triggerForceRemoveLock()"
                    [translate]="'DEVICE_LOCK.RESET_WARNING.FREE_LOCK'"
                    [disabled]="loading || !isResetWarningDisplayed()"
                ></button>
            </div>
        </div>
    } @else {
        @if (lockState$ | async; as lockState) {
            <p class="user-select-auto">
                @if (lockState?.ownerFingerprint?.clientId && !lockState?.ownedByMe) {
                    {{ 'DEVICE_LOCK.body.infoLocked' | translate }}
                } @else {
                    {{ 'DEVICE_LOCK.body.infoUnlocked' | translate }}
                }
            </p>
            <ul class="my-3">
                <li class="my-3 my-sm-0">
                    {{ 'DEVICE_LOCK.body.details.currentDevice' | translate }}:
                    <pace-core-device-lock-info [fingerprint]="myFingerprint"></pace-core-device-lock-info>
                </li>
                @if (!lockState?.ownerFingerprint?.clientId) {
                    <li class="my-3 my-sm-0">
                        {{ 'DEVICE_LOCK.body.details.lockingDevice' | translate }}:
                        {{ 'DEVICE_LOCK.body.details.lockingDeviceNone' | translate }}
                    </li>
                } @else if (lockState?.ownedByMe) {
                    <li class="my-3 my-sm-0">
                        {{ 'DEVICE_LOCK.body.details.lockingDevice' | translate }}:
                        <fa-icon [icon]="faCheck"></fa-icon>
                        {{ 'DEVICE_LOCK.body.details.lockingDeviceMe' | translate }}
                    </li>
                } @else {
                    <li class="my-3 my-sm-0">
                        {{ 'DEVICE_LOCK.body.details.lockingDevice' | translate }}:
                        <pace-core-device-lock-info
                            [fingerprint]="lockState.ownerFingerprint"
                        ></pace-core-device-lock-info>
                    </li>
                }
                <li class="my-3 my-sm-0">
                    {{ 'DEVICE_LOCK.body.details.time' | translate }}
                    <time [attr.datetime]="lockState?.acquiredAt" [title]="lockState?.acquiredAt">
                        {{ lockState?.acquiredAt | date: 'medium' }}
                    </time>
                </li>
            </ul>
        }
        <progressbar [class.invisible]="!loading" [value]="100" type="info" class="my-2">Loading...</progressbar>
        @if (actionLog.length) {
            <button
                class="fs-6 btn btn-link p-0 mt-3"
                (click)="toggleDetailsExpansion()"
                [attr.aria-label]="'DEVICE_LOCK.body.details.showLog' | translate"
            >
                <span class="pe-2" translate="DEVICE_LOCK.body.details.showLog"></span>
                <fa-icon [icon]="isDetailExpanded ? faChevronDown : faChevronRight"></fa-icon>
            </button>
            <div class="detail-section my-2 overflow-auto">
                <ul class="my-1 device-lock-error-action-log">
                    @for (logEntry of actionLog; track logEntry.ts) {
                        @if (isDetailExpanded || logEntry.emphasize) {
                            <li>
                                <time [attr.datetime]="logEntry.ts" [title]="logEntry.ts">
                                    {{ logEntry.ts | date: 'medium' }}
                                </time>
                                @if (logEntry.emphasize) {
                                    <strong>
                                        {{ logEntry.message | translate: logEntry.props }}
                                    </strong>
                                } @else {
                                    {{ logEntry.message | translate: logEntry.props }}
                                }
                            </li>
                        }
                    }
                </ul>
            </div>
        }
    }
</div>
<div class="modal-footer" *ngrxLet="isOnline$ as isOnline">
    @if (lockState$ | async; as lockState) {
        @if (allowUserToResetLock$ | async) {
            <button
                class="btn btn-warning"
                type="button"
                (click)="isResetWarningDisplayed.set(true)"
                [disabled]="loading || isResetWarningDisplayed() || !isOnline"
            >
                <span class="m-2" translate="DEVICE_LOCK.actions.forceUnlock"></span>
            </button>
        }

        @if (lockState?.ownedByMe) {
            <button
                class="btn btn-primary"
                type="button"
                (click)="triggerReleaseLock()"
                [disabled]="loading || isResetWarningDisplayed() || !isOnline"
            >
                <span class="m-2" translate="DEVICE_LOCK.actions.release"></span>
            </button>
        } @else {
            <button
                class="btn btn-primary"
                type="button"
                (click)="triggerAcquireLock()"
                [disabled]="loading || isResetWarningDisplayed() || !isOnline"
            >
                <fa-icon [icon]="isOnline ? faLock : faBan"></fa-icon>
                <span class="m-2" translate="DEVICE_LOCK.actions.acquire"></span>
            </button>
        }
    }
    @if (isDev) {
        <button
            class="btn btn-primary"
            type="button"
            (click)="triggerForceRemoveLock()"
            [disabled]="loading || isResetWarningDisplayed() || !isOnline"
        >
            <span class="m-2"> FORCE REMOVE </span>
        </button>
    }
</div>
